/**
 * usePoaRequiresRepresentative — live source for the reps requirement (§7).
 *
 * Legacy read it from `targetUser.requiresRepresentativePowerOfAttorney`, which
 * resolves from the org flag `requirePowerOfAttorneyRepresentatives` of the party
 * the order is placed for:
 *   - client-self: `useUserData().organizationData` (`/organization/me`).
 *   - admin-on-behalf: the SELECTED client's organization, captured by the admin
 *     gate as `targetRequiresPoaRepresentatives`. The admin's own organization
 *     describes the wrong party (QA-602: the client's org required both PoAs, the
 *     admin's did not, so only one was asked for and DocEstate refused the order).
 *
 * This value is captured into the DTO at config time (via the sync controller) so
 * the pure completeness predicate can gate without reading live `targetUser`.
 */

import { useUserData } from 'components/contexts/UserDataContext'
import { usePfStore } from 'components/pages/PurchaseFlowRevamp/store'

export function usePoaRequiresRepresentative(): boolean {
  const { organizationData } = useUserData()
  const targetUserId = usePfStore((s) => s.targetUserId)
  const targetRequiresPoaRepresentatives = usePfStore((s) => s.targetRequiresPoaRepresentatives)

  if (targetUserId) return targetRequiresPoaRepresentatives === true
  return !!organizationData?.requirePowerOfAttorneyRepresentatives
}
